// extracted by mini-css-extract-plugin
export var intro = "pricing-module--intro--I3l-U";
export var pageContent = "pricing-module--page-content--bfDNa";
export var sectionSpacingB = "pricing-module--section-spacing-b--sl5og";
export var sectionSpacingT = "pricing-module--section-spacing-t--RSHL5";